import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2, Wifi } from 'lucide-react'
import { useAuthStore } from '@/store/authStore'
import { ROUTES } from '@/constants'

const SplashPage = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        navigate(ROUTES.DASHBOARD, { replace: true })
      } else {
        navigate(ROUTES.LOGIN, { replace: true })
      }
    }, 2000)

    return () => clearTimeout(timer)
  }, [isAuthenticated, navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="w-24 h-24 bg-white/20 rounded-2xl flex items-center justify-center mb-6">
        <Wifi size={48} className="text-white" />
      </div>
      <h1 className="text-2xl font-bold text-white mb-2">BSNL FTTH</h1>
      <p className="text-blue-200 mb-8">Support Service</p>
      <Loader2 size={32} className="animate-spin text-white" />
    </div>
  )
}

export default SplashPage
